import React from "react";
import { Row, Col } from "react-bootstrap";
import Card from "../../Card";
// import ImageSlider from '../../ImageSlider';

import OneWayVision from "../../../../assets/images/PromotionalBoards/OneWayVision.jpg";
import Board from "../../../../assets/images/PromotionalBoards/Board.jpg";
import GlowBoard from "../../../../assets/images/PromotionalBoards/GlowBoard.avif";
import BackLight from "../../../../assets/images/PromotionalBoards/BackLightBoard.png";
import Lollipop from "../../../../assets/images/PromotionalBoards/Lollipop.jpg";
import Canopy from "../../../../assets/images/PromotionalBoards/Canopy.jpg";
import SunBoard from "../../../../assets/images/PromotionalBoards/CutOut.webp";

// Card Data
const cardData = [
  { image: Board, text: "Acrylic Sandwich Letter Boards" },
  { image: GlowBoard, text: "Glow Sign Boards" },
  { image: BackLight, text: "Back Light Vinyl Cutting Boards" },
  { image: Lollipop, text: "Flanges/ Lollipops" },
  { image: Canopy, text: "Promotional Canopy" },
  { image: SunBoard, text: "Vinyl Sunboard Cutouts" },
];

function HomeSection7() {
  return (
    <div className="mt-4 w-100 p-0">
      <h2 className="py-4 fw-bold text-center">Promotional Boards</h2>

      {/* 2nd row */}
      <Row className="align-items-center ">
        {/* Left side - Text */}
        <Col
          xs={12}
          md={6}
          className="d-flex flex-column justify-content-center"
          style={{ backgroundColor: "#f2f2f0", height: "400px" }}
        >
          <div className="text-center">
            <h2 className="fw-bold">One way vision board</h2>
            <p>
              These boards are perfect for adding privacy without compromising
              on natural light. Ideal for office spaces, storefronts, or any
              environment where you want to maintain a clear view from the
              inside while displaying eye-catching designs on the outside.
            </p>
          </div>
        </Col>

        {/* Right side - Image */}
        <Col xs={12} md={6} className="text-center pl-0">
          <img
            src={OneWayVision}
            alt="One way vision board"
            className="img-fluid w-100"
            style={{ height: "400px", objectFit: "cover" }}
          />
        </Col>
      </Row>

      {/* 2nd row */}
      <Row className="my-3">
        {cardData.slice(0, 6).map((card, index) => (
          <Col md={4} className="d-flex" key={index}>
            <Card image={card.image} text={card.text} />
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default HomeSection7;
